var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-table", {
    attrs: {
      hover: "",
      small: "",
      "caption-top": "",
      responsive: "sm",
      items: _vm.guests,
      fields: _vm.tableFields
    },
    scopedSlots: _vm._u(
      [
        {
          key: "cell(situation)",
          fn: function(ref) {
            var item = ref.item
            return [_vm._t("situation", null, { guest: item })]
          }
        },
        {
          key: "cell(type)",
          fn: function(data) {
            return [
              data.item.type === "user" ||
              data.item.entity_type === "App\\Models\\User"
                ? _c("span", [_vm._v("Usuário")])
                : data.item.type === "legal_entity" ||
                  data.item.entity_type === "App\\Models\\Corp\\LegalEntity"
                ? _c("span", [_vm._v("Pessoa Jurídica")])
                : data.item.type === "external_entity" || data.item.is_external
                ? _c("span", [_vm._v("Externo")])
                : data.item.type === "contact_list" ||
                  data.item.entity_type === "App\\Models\\Corp\\ContactList"
                ? _c("span", [_vm._v("Lista")])
                : _c("span", [_vm._v("Unidade Organizacional")])
            ]
          }
        },
        {
          key: "cell(name)",
          fn: function(data) {
            return [_c("span", [_vm._v(_vm._s(_vm.getEntityName(data)))])]
          }
        },
        {
          key: "cell(email)",
          fn: function(data) {
            return [_c("span", [_vm._v(_vm._s(_vm.getEntityEmail(data)))])]
          }
        },
        {
          key: "cell(confirmed)",
          fn: function(data) {
            return [
              _c(
                "div",
                { staticClass: "text-lg text-center flex gap-1 items-center" },
                [
                  _vm.guestHasJustifications(data.item)
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: {
                                content: "Abrir justificativa",
                                duration: { show: 100, hide: 100 }
                              },
                              expression:
                                "{content:'Abrir justificativa', duration:{show:100, hide:100}}"
                            }
                          ],
                          attrs: {
                            pill: "",
                            size: "sm",
                            variant: "outline-warning"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openJustifications(data.item)
                            }
                          }
                        },
                        [
                          _c("b-icon-exclamation-triangle", {
                            staticClass: "text-warning",
                            attrs: { "font-scale": "1" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  data.item.confirmed
                    ? _c("b-icon-check", {
                        key: "confirmed",
                        staticClass: "text-success",
                        attrs: { "font-scale": "2" }
                      })
                    : !_vm.guestHasJustifications(data.item)
                    ? _c("b-icon-x", {
                        key: "unconfirmed",
                        staticClass: "text-danger",
                        attrs: { "font-scale": "2" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          }
        },
        {
          key: "cell(action)",
          fn: function(data) {
            return [
              _vm.showActions
                ? _c("feather-icon", {
                    staticClass:
                      "h-5 w-5 mr-3 stroke-current text-danger cursor-pointer",
                    attrs: { icon: "XCircleIcon", size: "21" },
                    on: {
                      click: function($event) {
                        return _vm.removeGuest(data.item)
                      }
                    }
                  })
                : _vm._e()
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }